var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarehouseLocation = function SvgWarehouseLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19v19H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.906 16.625h-1.41l-.168-.147c-.203-.177-4.953-4.376-4.953-8.164A5.936 5.936 0 0 1 13.59 5.592l-1.056.545a4.75 4.75 0 0 0-8.972 2.177c0 2.9 3.575 6.374 4.386 7.124h.729c.098-.091.237-.223.407-.388l.831.847c-.377.37-.618.58-.618.58l-.168.148h-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.312 11.282a2.969 2.969 0 1 1 2.571-4.452l-1.027.594a1.781 1.781 0 1 0-1.544 2.671v1.187zm4.75 5.015-1.959-2.047a3.561 3.561 0 1 1 3.919 0l-1.96 2.047zm0-7.39a2.369 2.369 0 0 0-1.259 4.38l.112.092 1.147 1.2 1.26-1.293a2.368 2.368 0 0 0-1.26-4.378z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.469 10.689h1.187v1.187h-1.187z"
  })))));
};

export default SvgWarehouseLocation;